module.exports = __webpack_public_path__ + "static/media/ic_查看.65bc6521.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_查看.svg
// module id = 102
// module chunks = 0